module.exports = {
    // api:'http://10.10.10.59:9055',

    publicPath:'/static/m-evection-dev/'
}


// WEBPACK FOOTER //
// config/test.js